import * as Updates from 'expo-updates';
import { type UpdateFetchResult } from 'expo-updates';
import { fromPromise } from 'xstate5';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Checks for and fetches OTA updates.
 */
export const fetchUpdateIfAvailable = fromPromise<
  UpdateFetchResult | undefined
>(async function () {
  const checkForUpdateResult = await Updates.checkForUpdateAsync();

  if (!checkForUpdateResult.isAvailable) {
    return;
  }

  return Updates.fetchUpdateAsync();
});

/**
 * Restarts the app to apply the update.
 */
export const restartApp = fromPromise<void>(async function () {
  return Updates.reloadAsync();
});
